import { trpc } from '@/shared/api/trpc';

export const useCreateTask = () => {
  const utils = trpc.useUtils();
  return trpc.tasks.create.useMutation({
    onSettled: () => {
      utils.tasks.list.invalidate();
      utils.tasks.flaggedCount.invalidate();
      utils.tasks.getNextActions.invalidate();
      // A template task (admin create) joins a collection — refresh the
      // Collections tab counts + the collection's template-task preview.
      utils.taskCollections.list.invalidate();
      utils.taskCollections.templateTasks.invalidate();
    },
  });
};
